import { render, staticRenderFns } from "./TemplateLabel.vue?vue&type=template&id=1aaf5e76&scoped=true"
import script from "./TemplateLabel.vue?vue&type=script&lang=js"
export * from "./TemplateLabel.vue?vue&type=script&lang=js"
import style0 from "./TemplateLabel.vue?vue&type=style&index=0&id=1aaf5e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf5e76",
  null
  
)

export default component.exports